import ProgrammeImage1 from "../../../../../assets/images/png/courses/programme1.webp";
import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/liyide.jpeg";
import SchoolImage from "../../../../../assets/images/png/school/data-school.webp";

export const cyberSecuritySchoolAfrica = {
  tag: "Cybersecurity",
  id: "cybersecuritySchool",
  url: "/cybersecurity-school",
  image: SchoolImage,

  name: "Cybersecurity School",
  description: `This comprehensive program equips you with the essential skills needed to excel as a security expert.`,
  keywords: `Cybersecurity, Security`,
  metatags: `Gain expertise in evaluating, preserving, and overseeing the safety of computer systems`,
  courses: [
    {
      id: 1,
      courseImage: ProgrammeImage1,
      courseName: "Cybersecurity Bootcamp",
      courseDescription: `
      Begin your journey towards a cybersecurity profession. This comprehensive program equips you with the essential skills needed to excel as a security expert.
    `,
      courseStartDate: "December 2, 2023",

      courseDuration: "5 Months",

      courseTags: ["For Early Professionals"],

      courseUrl: "/cybersecurity-bootcamp",

      enrolUrl: "",
    },
  ],

  testimony: {
    testimonierImage: TestimonialImage,
    testimonierName: "Ajibola Liyide",
    testimonierTitle: "Internal, External and Media Relations",
    testimonyDescription: `The Utiva training with Utiva has been challenging and inspiring. 
    Challenging because it is at the same time as the re-branding project in my office. Inspiring 
    because I have learnt a lot so far. The key point is that the user experience is the most important factor to add value and provide solutions. `,
  },

  article: [],

  careerTitle: "Cybersecurity Expert",

  careerPaths: ["cybersecurity Expert"],

  quickFactSalary: "$124,000",

  quickFacts: [
    "Cybersecurity expert has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum, citing it as the next wave of information technology for individuals, companies and governments.",
  ],
};
